const appUrl = process.env.NEXT_PUBLIC_SITE_URL;
const serviceDomain = process.env.NEXT_PUBLIC_WEB_SERVICES_DOMAIN;

export const HeaderFooterApiEndpoints = {
  HEADER_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/in/en/xaop-header/shares-header-experience-fragment/master.headless.json`,
  MOB_HEADER_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/{version}/en/xaop-header/shares-header-experience-fragment/master.headless.json`,
  FOOTER_CONTENT: `${appUrl}/content/experience-fragments/bajajfinserv/web/in/en/xaop-footer/footer/master.headless.json`,
  SEARCH_CONTENT: `${serviceDomain}/api/v5/autocomplete`,
};
